export const SET_SAT_IDENTIFICATION_COLLECTION = 'SAT/SET_SAT_IDENTIFICATION_COLLECTION';
